<template>
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="user-accoount-row"
        transform="translate(-1437, -10)"
        fill="#359685"
        fill-rule="nonzero"
      >
        <g id="edit_FILL0_wght400_GRAD0_opsz24" transform="translate(1437, 10)">
          <path
            id="Shape"
            d="M2,16 L3.425,16 L13.2,6.225 L11.775,4.8 L2,14.575 L2,16 Z M0,18 L0,13.75 L13.2,0.575 C13.4,0.391666667 13.6208333,0.25 13.8625,0.15 C14.1041667,0.05 14.3583333,0 14.625,0 C14.8916667,0 15.15,0.05 15.4,0.15 C15.65,0.25 15.8666667,0.4 16.05,0.6 L17.425,2 C17.625,2.18333333 17.7708333,2.4 17.8625,2.65 C17.9541667,2.9 18,3.15 18,3.4 C18,3.66666667 17.9541667,3.92083333 17.8625,4.1625 C17.7708333,4.40416667 17.625,4.625 17.425,4.825 L4.25,18 L0,18 Z M16,3.4 L14.6,2 L16,3.4 Z M12.475,5.525 L11.775,4.8 L13.2,6.225 L12.475,5.525 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
